import { isDashmoteStaffEmail } from "../slices/authSlice";

/**
 * The signed-in caller's own market boundary for a workspace.
 *
 * Admins get all products for their assigned countries, so
 * a market-scoped admin may only manage the markets they themselves hold. This
 * returns the flat set of those country codes, or `null` when the caller is
 * UNRESTRICTED for the workspace — Dashmote staff (`@dashmote.com`) or a
 * `super_admin` of that workspace.
 *
 * This is UX / defense-in-depth only: it limits which markets the invite/edit
 * pickers offer. The backend (`caller_country_scope`) re-derives and enforces
 * the same boundary from the verified token, so a bypass here changes nothing
 * server-side.
 *
 * @param {object} userData - the signed-in user's record (Redux `auth.userData`)
 * @param {string} workspaceId - the workspace whose scope to resolve
 * @returns {Set<string>|null} the caller's market set, or null if unrestricted
 */
export function getCallerMarketScope(userData, workspaceId) {
  if (isDashmoteStaffEmail(userData?.email)) return null;
  const ws = userData?.id_client?.[workspaceId];
  const role = (ws?.role || "").toLowerCase().replace(/\s+/g, "_");
  if (role === "super_admin") return null;
  const scope = new Set();
  Object.values(ws?.product_scopes || {}).forEach((list) =>
    (list || []).forEach((country) => scope.add(country))
  );
  return scope;
}
